import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ApiBackendClient } from "../helpers/api_backend_helper";

export const menuItems = [
  {
    id: "inicio",
    label: "Inicio",
    link: "/menu-inicio",
  },

  {
    id: "configuracion",
    label: "Configuración",
    description: "Configuración del sistema",
    link: "/configuracion",
    subItems: [
      {
        id: "seguridad-sistema",
        label: "Seguridad del sistema",
        description: "Configuración de seguridad del sistema",
        link: "/configuracion/seguridad",
        parentId: "configuracion",
      },
      {
        id: "empresas",
        label: "Empresas",
        description: "Configuración de empresas",
        link: "/configuracion/empresas",
        parentId: "configuracion",
      },
    ],
  },
  {
    id: "bodega",
    label: "Bodega",
    description: "Gestión de compras y abastecimiento",
    link: "/bodega",
    subItems: [
      {
        id: "bodega-maestro-productos",
        label: "Maestro de productos",
        description: "Maestro de productos",
        link: "/bodega/maestro-productos",
        parentId: "bodega",
      },
      {
        id: "bodega-calculos",
        label: "Cálculos",
        description: "Cálculos de reposición y sugeridos",
        link: "/bodega/calculos",
        parentId: "bodega",
        isChildItem: true,
        childItems: [
          {
            id: "bodega-calculos-reposicion",
            label: "Cálculos de reposición",
            description: "Cálculos de reposición",
            link: "/bodega/calculos/reposicion",
            parentId: "bodega-calculos",
          },
          {
            id: "bodega-calculos-sugeridos",
            label: "Calculo de sugeridos",
            description: "Cálculos de sugeridos",
            link: "/bodega/calculos/sugeridos",
            parentId: "bodega-calculos",
          },
        ],
      },
      {
        id: "bodega-parametros",
        label: "Parámetros bodega",
        description: "Configuración de parámetros de bodega",
        link: "/bodega/parametros",
        parentId: "bodega",
        isChildItem: true,
        childItems: [
          {
            id: "bodega-clasificaciones",
            label: "Clasificaciones",
            link: "/bodega/parametros/clasificaciones",
            parentId: "bodega-parametros",
          },
          {
            id: "bodega-familias-productos",
            label: "Familias de Productos",
            link: "/bodega/parametros/familias-productos",
            parentId: "bodega-parametros",
          },
        ],
      },
    ],
  },
  {
    id: "rent-a-car",
    label: "Rent a Car",
    description: "Arriendo de vehículos",
    link: "/rent-a-car",
    subItems: [
      {
        id: "vehiculos-rent-a-car",
        label: "Vehículos",
        link: "/rent-a-car/vehiculos",
        parentId: "rent-a-car",
      },
      {
        id: "contratos-arriendo",
        label: "Contratos de arriendo",
        link: "/rent-a-car/contratos-arriendo",
        parentId: "rent-a-car",
      },
    ],
  },
  {
    id: "post-venta",
    label: "Post Venta",
    description: "Gestión de post venta",
    link: "/post-venta",
    subItems: [
      {
        id: "call-center-post-venta",
        label: "Call center",
        link: "/post-venta/call-center",
        parentId: "post-venta",
      },
      {
        id: "reclamos-post-venta",
        label: "Reclamos",
        link: "/post-venta/reclamos",
        parentId: "post-venta",
      },
    ],
  },
  {
    id: "caja-facturacion",
    label: "Caja / Facturación",
    description: "Gestión de caja y facturación",
    link: "/caja-facturacion",
    subItems: [
      {
        id: "caja-diaria-caja-facturacion",
        label: "Caja diaria",
        link: "/caja-facturacion/caja-diaria",
        parentId: "caja-facturacion",
      },
      {
        id: "maestro-clientes-caja-facturacion",
        label: "Maestro de clientes",
        link: "/caja-facturacion/maestro-clientes",
        parentId: "caja-facturacion",
      },
    ],
  },

  {
    id: "recepcion-vehiculo",
    label: "Recepción Vehículos",
    description: "Recepción y entrega de vehículos",
    link: "/recepcion-vehiculo",
    subItems: [
      {
        id: "recepcion-vehiculo-citas",
        label: "Citas",
        link: "/recepcion-vehiculo/citas",
        parentId: "recepcion-vehiculo",
      },
      {
        id: "recepcion-vehiculo-historial-recepciones",
        label: "Historial recepciones",
        link: "/recepcion-vehiculo/historial-recepciones",
        parentId: "recepcion-vehiculo",
      },
    ],
  },
  {
    id: "file-manager",
    label: "Transferencia de archivos",
    description: "Sube y descarga archivos al ERP",
    link: "/file-manager",
  },
  {
    id: "contabilidad",
    label: "Contabilidad",
    description: "Gestión contable",
    link: "/contabilidad",
    subItems: [
      {
        id: "maestro-dcv",
        label: "Maestro DCV",
        description: "Maestro de Documentos de Compras, Ventas Honorarios, Anticipos",
        link: "/contabilidad/maestro-dcv",
        parentId: "contabilidad",
      },
      {
        id: "plantillas-cobranza",
        label: "Plantillas de Notificación",
        description: "Gestión de plantillas de notificación de cobranza",
        link: "/cobranza/plantillas",
        parentId: "contabilidad",
      },
    ],
  }
];

const itemsSinInicio = menuItems.filter((item) => item.id !== "inicio");
const itemsOrdenados = itemsSinInicio.sort((a, b) =>
  a.label.localeCompare(b.label)
);
const menuConInicioAlPrincipio = [
  menuItems.find((item) => item.id === "inicio"),
  ...itemsOrdenados,
];
// ordena subItems y childItems
menuConInicioAlPrincipio.forEach((item) => {
  if (item.subItems) {
    item.subItems.sort((a, b) => a.label.localeCompare(b.label));
  }
  if (item.childItems) {
    item.childItems.sort((a, b) => a.label.localeCompare(b.label));
  }
});

export const menuItems2 = menuConInicioAlPrincipio;

const Navdata = () => {
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState([]);
  const tenantId = useSelector((state) => state.Context.tenantId);
  const apiClient = new ApiBackendClient();

  useEffect(() => {
    const fetchMenuData = async () => {
      if (tenantId) {
        try {
          const response = await apiClient.get("/menu", { tenantId });
          console.log(response)
          setMenuItems(response);
        } catch (error) {
          console.error("Error fetching menu:", error);
          // Fallback to hardcoded menu if API fails
          setMenuItems(menuConInicioAlPrincipio);
        }
      } else {
        // Fallback if no tenantId
        setMenuItems(menuConInicioAlPrincipio);
      }
    };
    fetchMenuData();
  }, [navigate, tenantId]);

  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
